<div class="mainContainer">
  <canvas width="100%" height="100%" #canvas class="focus-canvas" id="focus"></canvas>
</div>